<!-- 新闻发布 -->
<template>
    <div class="page-form">
        <Breadcrumb :title="title" />
        <div class="detail-wrap" >
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" 
                label-width="100px" class="demo-ruleForm">                   
                <el-row class="size20">
                    <el-form-item label="新闻标题" prop="title">
                        <el-input type="text" v-model="ruleForm.title" placeholder="请输入内容"/>
                    </el-form-item>    
                </el-row>
                <!-- <el-row>
                    <el-form-item label="新闻简介" prop="intro">  
                        <el-input type="textarea"  :rows="10" v-model="ruleForm.intro" placeholder="请输入内容"/>
                    </el-form-item>
                </el-row> -->
                <el-row> 
                    <el-form-item label="新闻详情" prop="des">
                        <el-input type="textarea" :rows="20" v-model="ruleForm.des" placeholder="请输入内容"/>
                    </el-form-item>
                </el-row>
                <el-row>
                <el-form-item label="新闻图片" prop="imageUrl" class="form" >
                    <el-upload class="avatar-uploader" ref="coverPicUpload" action="" list-type="picture-card" accept="image/*"
                        multiple :limit="1" name="file" :show-file-list="false" :http-request="handleRequest"
                        :before-upload="handleBeforeUpload" :on-error="handleUploadError">
                        <el-image v-if="!ruleForm.imageUrl" :src="ruleForm.imageUrl">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-plus" />
                        </div>
                        </el-image>
                        <div v-else class="image">
                        <el-image :src="ruleForm.imageUrl" :style="`width:150px;height:150px;`" fit="fill"/>
                        <div class="mask">
                            <div class="actions">
                            <span title="移除" @click.stop="handleRemove">
                                <i class="el-icon-delete" />
                            </span>
                            </div>
                        </div>
                        </div>
                    </el-upload>
                    <el-row>
                        <el-form-item>
                            <el-button round block type="primary" @click="submitForm('ruleForm')" 
                            class="pub-submit" :disabled="disabled">
                                发布
                            </el-button>                            
                        </el-form-item>
                    </el-row>
                </el-form-item>
            </el-row>
        </el-form>
    </div>
</div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
    components:{
        Breadcrumb,
    },
    data() {
        return {
            ruleForm: {
                title: '',
                intro: '',
                des: '',
                imageUrl: '',                
            },
            rules:{
                title:[
                    { required: true, message: '请输入新闻标题', trigger: 'blur' },
                ],
                // intro: [
                //     { required: true, message: '请输入新闻简介', trigger: 'blur' },
                // ],
                des: [
                    { required: true, message: '请输入新闻详情', trigger: 'blur' },
                ],
                imageUrl: [
                    { required: false, message: '请上传图片', trigger: 'change' },
                ],
            },
            disabled: false,
            imageUrl: '',
            serialId: '',
            flag: 1,
        }
    },
    created() {
        this.serialId = this.$route.query.id
    },
    mounted() {
        if(this.serialId){
            this.initData()
        }
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.NewsQuery,
                i_serial: this.serialId,
                v_title: '',               
                start_date: 0,
                end_date: 0,
                pagesize: 10,
                page: 1,        
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){
                        let list = result.map(item=>{
                            return{
                                imageUrl: this.$global.uploadUrl + item['图片'],
                                title: item['标题'],
                                intro: item['简介'],
                                des: item['详情'],
                            }
                        })   
                        console.log(list)
                        this.ruleForm = {...list[0]}  
                    }     
                }
            })
        },
        submitForm(formName){             
            this.$refs[formName].validate((valid) => {    
                if(valid){
                    this.handleSubmit()
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        handleSubmit(){
            let {title,des} = this.ruleForm
            if(this.serialId){
                this.flag = 2
            }else{
                this.flag = 1
            }
            let params = {
                opcode: this.$code.AddUpdateNews,
                i_serial: this.serialId,
                v_title: title,
                v_introduction: '',
                v_details: des,
                v_image: this.imageUrl,
                c_status: 0,
                i_flag: this.flag,
                v_flag: 1,               
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.disabled = true 
                    this.$message.success(res.Message)
                    if(this.serialId){
                        this.$router.push('/newsQuery')
                    }else{
                        this.$router.go(-1)
                    }
                }
            })
        },
        async handleRequest(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.imageUrl= url
            this.ruleForm.imageUrl = this.$global.uploadUrl + url
            console.log(this.ruleForm.imageUrl)
            this.loading.close();
            this.$refs.coverPicUpload.clearFiles()
        },  
        handleRemove(file, fileList) {
            this.imageUrl = ''
            this.ruleForm.imageUrl = ''
        },   
        handleBeforeUpload() {
            this.loading = true
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        },
        handleUploadError() {
            // this.loading = false
            // this.$message({
            //     type: "error",
            //     message: "上传失败",
            // });
            // this.loading.close();
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}


.image {
  position: relative;

  .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }

  &:hover .mask {
    opacity: 1;
  }
}
.container {
    background-color: #fff;
}

.detail-wrap {
    width: 750px;
    padding: 30px 60px;
    font-size: 16px;
    line-height: 28px;
}
.pub-title{
    text-align: center;
    font-size: 20px;
}
.sub-title{
    padding: 4px 15px;
    font-size: 18px;
    color: #fff;
    background-color: #e62e02;
    border-radius: 5px;
}
.sub-name{
    padding: 10px;
}
.mg-t-20{
    margin-top: 30px;
}
.pub-submit{
    margin-top: 16px;
    width: 20%;
    font-size: 16px;
}

</style>


// WEBPACK FOOTER //
// src/views/news/news.vue